/* eslint-disable max-len */
const CURRENT_SWEEPSTAKES_ID = 'fifa-2026'; // Use 'generic' afterwards
const UNAUTHENTICATED_SWEEPSTAKES_STATES = {
  generic: {
    id: 'generic-unauthenticated',
    title: 'Enter to Win!',
    description: 'Join thousands of Home Depot customers competing for our current giveaway!',
    logo: 'https://assets.thdstatic.com/images/v1/loyaltyBenefits/SweepstakesIcon.svg',
    status: 'New',
  },
  'fifa-2026': {
    id: 'fifa-2026-unauthenticated',
    title: 'Enter to Win FIFA World Cup 2026™ Tickets!',
    description:
      'Join thousands of Home Depot customers competing for the ultimate FIFA World Cup 2026™ experience.',
    logo: 'https://assets.thdstatic.com/images/v1/loyaltyBenefits/icon-fifa-world-cup-2026.svg',
    status: 'New',
  }
};
export const SWEEPSTAKES_MOCK_DATA = {
  unauthenticated: UNAUTHENTICATED_SWEEPSTAKES_STATES[CURRENT_SWEEPSTAKES_ID],
  notOptedIn: {
    challengeId: 'fifa-2026',
    customerChallengeId: '85197cc0-9a6a-422b-b292-bf686a901957',
    name: 'FIFA World Cup 2026™ Giveaway',
    description: 'Participate in 4 different ways for a chance to win tickets to a FIFA World Cup 2026™ soccer match!',
    imageUrl: 'https://assets.thdstatic.com/images/v1/loyaltyBenefits/icon-fifa-world-cup-2026.svg',
    challengeEndDate: '04/22/2026',
    challengeStatus: 'ACTIVE',
    termsAndConditions: '**Important Details:**\n* This giveaway will run from 03/19/2026-04/22/2026\n* To edit your personal details or match selections, please call (770) 433-8211\n* If selected as a winner, you will be contacted by phone or email to confirm your personal details\n* These giveaway prizes cannot be redeemed for cash or credit.',
    optedStatus: 'NOT_OPTED',
    activityStatus: 'ELIGIBLE',
    challengeStepsCompleted: 0,
    challengeStepsTotal: 4,
    tasks: [
      {
        customerTaskId: 'ae114c51-ca7a-41de-832a-24f82291d00a',
        name: 'Take a Survey',
        description: 'Earn your first entry by taking the survey below.',
        status: 'NOT_STARTED',
        evalParamName: 'count',
        evalParamValue: '1',
        targetParamValue: '1',
      },
      {
        customerTaskId: 'b9594694-5008-40ae-baad-e6e836040724',
        name: 'Turn on Notifications',
        description: '**To Turn On Notifications:**\n\n1. Open the Settings app\n2. Tap on Notifications\n   -If you have an Android device, tap App Notifications to see your installed apps\n3. Select The Home Depot app under Notification Style\n4. Tap the Allow Notifications toggle to turn it on\n   -The toggle will turn green\n\n**Important Details on Managing Alerts:**\n\nFrom the Lock Screen:\n* Tap a single notification to open the corresponding app\n* Touch and hold the notification for quick access without opening the app\n* If you missed an alert, swipe up from the middle of your Lock Screen\n\n**From the Home Screen:**\n* Tap the banner as it appears to open the corresponding app',
        status: 'NOT_STARTED',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_notifications',
      },
      {
        customerTaskId: 'c7685804-6119-41ef-baad-e7e936040735',
        name: 'Experience Store Mode',
        description: '**To Experience Store Mode:**\n\n1. Open The Home Depot app\n   -You must be in store to use Store Mode\n2. Select your store\n   -The app may automatically detect it\n3. Search for a product\n4. Tap on the map icon to see its location within the store\n\n**Important Details About Store Mode:**\n\nStore Mode can be used while shopping at any Home Depot store location. Store Mode helps you plan your trip efficiently and unlocks the following benefits:\n\n* Pre-select desired items online\n* Get personalized product recommendations\n* Optimize your in-store route for faster shopping',
        status: 'NOT_STARTED',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_store-mode',
      },
      {
        customerTaskId: 'd8796915-7220-52fg-cbbc-f8f047151846',
        name: 'Purchase via the App',
        description: 'Make a qualifying purchase through The Home Depot app to complete this step.',
        status: 'NOT_STARTED',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_shop',
      },
    ],
    challengeMetaData: {
      bonusEntry_postText: '**GOAL! Bonus entry earned.**',
      bonusEntry_preText: '**Complete all 4 entries, earn a 5th on us!**',
      bonusEntry_img: 'true',
      bonusEntryEligible: 'true',
      sweepstakesCard_description: 'You\'ve got four shots to win FIFA World Cup 2026™ tickets, a backyard makeover, replica balls & more.',
      stepTrackerIcon: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/Soccerball.svg%203.svg',
      drawerBannerImage: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/FIFA_Banner.svg',
      preOptInDrawer_cta: 'Take Survey',
      preOptInDrawer_checkbox_1: 'I agree to receive The Home Depot communications via email. I can always update my preferences later.',
      preOptInDrawer_checkbox_2: 'I agree to the [Terms & Conditions](http://homedepot.com/c/pro-xtra-terms-and-conditions) and [Privacy Policy](https://www.homedepot.com/privacy/privacy-and-security-statement)',
      preOptInDrawer_checkbox_3: 'I am **not** an active Home Depot associate',
      'Sweeps FAQ\'s': 'http://www.homedepot.com/c/fifa-world-cup-2026',
      type: 'SWEEPSTAKES',
      typeOfChallenge: 'sweepstakes',
    },
  },
  partiallyCompleted: {
    challengeId: 'fifa-2026',
    customerChallengeId: '85197cc0-9a6a-422b-b292-bf686a901957',
    name: 'FIFA World Cup 2026™ Giveaway',
    description: 'Participate in 4 different ways for a chance to win tickets to a FIFA World Cup 2026™ soccer match!',
    imageUrl: 'https://assets.thdstatic.com/images/v1/loyaltyBenefits/icon-fifa-world-cup-2026.svg',
    challengeEndDate: '04/22/2026',
    challengeStatus: 'ACTIVE',
    termsAndConditions: '**Important Details:**\n* This giveaway will run from 03/19/2026-04/22/2026\n* To edit your personal details or match selections, please call (770) 433-8211\n* If selected as a winner, you will be contacted by phone or email to confirm your personal details\n* These giveaway prizes cannot be redeemed for cash or credit.',
    optedStatus: 'OPTED_IN',
    activityStatus: 'OPTED_IN',
    challengeStepsCompleted: 2,
    challengeStepsTotal: 4,
    tasks: [
      {
        customerTaskId: 'ae114c51-ca7a-41de-832a-24f82291d00a',
        name: 'Take a Survey',
        description: 'Earn your first entry by taking the survey below.',
        status: 'COMPLETED',
        evalParamName: 'count',
        evalParamValue: '1',
        targetParamValue: '1',
      },
      {
        customerTaskId: 'b9594694-5008-40ae-baad-e6e836040724',
        name: 'Turn on Notifications',
        description: '**To Turn On Notifications:**\n\n1. Open the Settings app\n2. Tap on Notifications\n   -If you have an Android device, tap App Notifications to see your installed apps\n3. Select The Home Depot app under Notification Style\n4. Tap the Allow Notifications toggle to turn it on\n   -The toggle will turn green\n\n**Important Details on Managing Alerts:**\n\nFrom the Lock Screen:\n* Tap a single notification to open the corresponding app\n* Touch and hold the notification for quick access without opening the app\n* If you missed an alert, swipe up from the middle of your Lock Screen\n\n**From the Home Screen:**\n* Tap the banner as it appears to open the corresponding app',
        status: 'COMPLETED',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_notifications',
      },
      {
        customerTaskId: 'c7685804-6119-41ef-baad-e7e936040735',
        name: 'Experience Store Mode',
        description: '**To Experience Store Mode:**\n\n1. Open The Home Depot app\n   -You must be in store to use Store Mode\n2. Select your store\n   -The app may automatically detect it\n3. Search for a product\n4. Tap on the map icon to see its location within the store\n\n**Important Details About Store Mode:**\n\nStore Mode can be used while shopping at any Home Depot store location. Store Mode helps you plan your trip efficiently and unlocks the following benefits:\n\n* Pre-select desired items online\n* Get personalized product recommendations\n* Optimize your in-store route for faster shopping',
        status: 'NOT_STARTED',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_store-mode',
      },
      {
        customerTaskId: 'd8796915-7220-52fg-cbbc-f8f047151846',
        name: 'Purchase via the App',
        description: 'Make a qualifying purchase through The Home Depot app to complete this step.',
        status: 'NOT_STARTED',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_shop',
      },
    ],
    challengeMetaData: {
      bonusEntry_postText: '**GOAL! Bonus entry earned.**',
      bonusEntry_preText: '*Complete all 4 entries, earn a 5th on us!**',
      bonusEntry_img: 'true',
      bonusEntryEligible: 'true',
      sweepstakesCard_description: 'You\'ve got four shots to win FIFA World Cup 2026™ tickets, a backyard makeover, replica balls & more.',
      stepTrackerIcon: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/Soccerball.svg%203.svg',
      drawerBannerImage: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/FIFA_Banner.svg',
      stepTracker_postOptIn_preRequistie_drawer_description: 'To participate and earn your first entry, fill out the survey by selecting the task below. Earn more entries for a better chance to win by completing the other tasks.\n\nAll additional entries are optional and can be completed in any order of events.',
      stepTracker_leanrMore_text: '[Learn more](http://www.homedepot.com/c/fifa-world-cup-2026) about how the Home Depot is gearing up for the FIFA World Cup 2026™.\nLet\'s get you World Cup ready!',
      all_entries_completed_text: 'All tasks completed! 4 entries earned.\nThe winners will be selected and notified through email by 04/29/2026.',
      'Sweeps FAQ\'s': 'http://www.homedepot.com/c/fifa-world-cup-2026',
      type: 'SWEEPSTAKES',
      typeOfChallenge: 'sweepstakes',
    },
  },
  fullyCompleted: {
    challengeId: 'fifa-2026',
    customerChallengeId: '85197cc0-9a6a-422b-b292-bf686a901957',
    name: 'FIFA World Cup 2026™ Giveaway',
    description: 'Participate in 4 different ways for a chance to win tickets to a FIFA World Cup 2026™ soccer match!',
    imageUrl: 'https://assets.thdstatic.com/images/v1/loyaltyBenefits/icon-fifa-world-cup-2026.svg',
    challengeEndDate: '04/22/2026',
    challengeStatus: 'ACTIVE',
    termsAndConditions: '**Important Details:**\n* This giveaway will run from 03/19/2026-04/22/2026\n* To edit your personal details or match selections, please call (770) 433-8211\n* If selected as a winner, you will be contacted by phone or email to confirm your personal details\n* These giveaway prizes cannot be redeemed for cash or credit.',
    optedStatus: 'OPTED_IN',
    activityStatus: 'OPTED_IN',
    challengeStepsCompleted: 4,
    challengeStepsTotal: 4,
    tasks: [
      {
        customerTaskId: 'ae114c51-ca7a-41de-832a-24f82291d00a',
        name: 'Take a Survey',
        description: 'Earn your first entry by taking the survey below.',
        status: 'COMPLETED',
      },
      {
        customerTaskId: 'b9594694-5008-40ae-baad-e6e836040724',
        name: 'Turn on Notifications',
        description: '**To Turn On Notifications:**\n\n1. Open the Settings app\n2. Tap on Notifications\n3. Select The Home Depot app under Notification Style\n4. Tap the Allow Notifications toggle to turn it on',
        status: 'COMPLETED',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_notifications',
      },
      {
        customerTaskId: 'c7685804-6119-41ef-baad-e7e936040735',
        name: 'Experience Store Mode',
        description: '**To Experience Store Mode:**\n\n1. Open The Home Depot app\n2. Select your store\n3. Search for a product\n4. Tap on the map icon to see its location within the store',
        status: 'COMPLETED',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_store-mode',
      },
      {
        customerTaskId: 'd8796915-7220-52fg-cbbc-f8f047151846',
        name: 'Purchase via the App',
        description: 'Make a qualifying purchase through The Home Depot app to complete this step.',
        status: 'COMPLETED',
        eventBusTrigger: 'loyalty-benefits.sweepstakes_step-cta_shop',
      },
    ],
    challengeMetaData: {
      bonusEntry_postText: '**GOAL! Bonus entry earned.**',
      bonusEntry_preText: '*Complete all 4 entries, earn a 5th on us!**',
      bonusEntry_img: 'true',
      bonusEntryEligible: 'true',
      sweepstakesCard_description: 'You\'ve got four shots to win FIFA World Cup 2026™ tickets, a backyard makeover, replica balls & more.',
      stepTrackerIcon: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/Soccerball.svg%203.svg',
      drawerBannerImage: 'https://storage.googleapis.com/storage.hd-loyalty-stage.gcp.homedepot.com/Sweepstakes/FIFA_Banner.svg',
      all_entries_completed_text: 'All tasks completed! 4 entries earned.\nThe winners will be selected and notified through email by 04/29/2026.',
      'Sweeps FAQ\'s': 'http://www.homedepot.com/c/fifa-world-cup-2026',
      type: 'SWEEPSTAKES',
      typeOfChallenge: 'sweepstakes',
    },
  },
};

export const SWEEPSTAKES_OPT_IN_CONTENT = {
  title: 'WIN FIFA WORLD CUP TICKETS!',
  content: 'Want to be there when the world watches history unfold? Here\'s your chance to win exclusive '
    + 'FIFA World Cup tickets—and the more you participate, the better your chances!\n\n'
    + '**How It Works**\n\n'
    + 'Earn entries by completing fun and simple tasks. Each task you complete adds more entries to your '
    + 'name, boosting your odds of winning the ultimate soccer experience.\n\n'
    + '**The More You Do, The Better Your Odds!**\n\n'
    + 'Track your progress, unlock achievements, and climb the leaderboard. Every action brings you '
    + 'closer to the pitch.\n\n'
    + '**To Get Started**\n\n'
    + 'Enter the sweepstakes and earn your first entry by taking the survey below!\n\n'
    + '**The Winning Prizes**\n\n'
    + '**First Prize:** One winner and guest will receive an all expenses paid trip to the World Cup '
    + 'Finals in New York (July 18-20, 2026), and a FIFA World Cup backyard makeover!\n\n'
    + '* Roundtrip flights and accommodations\n'
    + '* Visa gift card for food and beverage\n'
    + '* Official FIFA World Cup gifting\n'
    + '* Backyard makeover by The Home Depot\n\n'
    + '**Second Prize:** Ten winners will receive a pair of match tickets in preferred market of choice '
    + '(travel not included).\n\n'
    + '**Third Prize:** Around 800 winners will receive an official FIFA World Cup Replica Ball!',
  ctaTitle: 'Take Survey',
  termsText: 'I agree to the terms and conditions',
  associateText: 'I confirm I am not an associate',
};

export const SWEEPSTAKES_SURVEY_CONTENT = {
  title: 'SURVEY',
  content: '',
  ctaTitle: 'Let\'s Do This!',
};

export const SWEEPSTAKES_DETAILS_CONTENT = {
  title: 'Sweepstakes Details',
  initialParagraph: 'You\'ve officially joined the sweepstakes! Earn more entries for a better chance to win by '
    + 'completing the tasks below.\n\nAll additional entries are optional and can be completed in any order of events.',
  stepsHeader: 'To Earn Sweepstakes Entries:',
  expiresText: 'Expires 4/09/2026',
  termsAndConditions: '**Important Details About the Sweepstakes:**\n\n'
    + '• This sweepstakes will run for a duration of three weeks (03/19/2026 - 04/09/2026)\n\n'
    + '• If selected as a winner, you will be contacted over email or phone to confirm your personal details and '
    + 'match selections\n\n'
    + '• The prizes included in this sweepstakes cannot be redeemed for cash or credit',
};